import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_shirts_blouses: FaireCategoryEntity = {
  token: "cat_women-shirts-blouses",
  type: "category",
  name: "Shirts & blouses",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/shirts-blouses",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
